import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { PropsWithoutChildren } from '../../utils/utilityTypes';
import { classes } from '../../utils/utils';
import styles from './MarkerIcon.module.css';
export enum MarkerIconColor {
  Red = 'red',
}
export type MarkerIconProps = PropsWithoutChildren<ComponentProps<'svg'>> & {
  color?: MarkerIconColor;
};
export const MarkerIcon: FunctionComponent<MarkerIconProps> = React.memo(props => {
  const $ = _c(11);
  let t0;
  let t1;
  let xmlnsAttributes;
  if ($[0] !== props) {
    const {
      color: t2,
      className,
      ...remainingProps
    } = prepareProps({
      props,
      ignoreChildren: true
    });
    const color = t2 === undefined ? MarkerIconColor.Red : t2;
    let t3;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
        "xmlns:svg": "http://www.w3.org/2000/svg"
      };
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    xmlnsAttributes = t3;
    t0 = remainingProps;
    t1 = classes(styles.svg, className, colorToClassName[color]);
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
    $[3] = xmlnsAttributes;
  } else {
    t0 = $[1];
    t1 = $[2];
    xmlnsAttributes = $[3];
  }
  let t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <rect className={styles.markerBackground} width="239.09798" height="243.5923" x="74.493271" y="3.2643127" ry="1.19796" />;
    t3 = <path className={styles.marker} d="M 207.749,435.95333 C 356.44076,227.69613 383.75748,206.51794 385.01174,129.11511 386.72982,23.090027 302.17286,-64.252452 196.14779,-65.970524 90.122702,-67.688596 2.7802235,16.868357 1.0621514,122.89343 c -1.25426613,77.40285 25.3619336,99.45498 167.2280286,312.4205 9.31058,13.92667 29.70292,14.25612 39.45882,0.6394 z M 191.74076,205.99377 c -44.17719,-0.71586 -79.40917,-37.10848 -78.69331,-81.28568 0.71587,-44.177199 37.10848,-79.40918 81.28568,-78.693316 44.1772,0.715865 79.40919,37.10848 78.69332,81.285686 -0.71587,44.17719 -37.10848,79.40917 -81.28569,78.69331 z" />;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t0 || $[8] !== t1 || $[9] !== xmlnsAttributes) {
    t4 = <svg {...t0} className={t1} viewBox="-10 -70 400 520" {...xmlnsAttributes}>{t2}{t3}</svg>;
    $[7] = t0;
    $[8] = t1;
    $[9] = xmlnsAttributes;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
});
const colorToClassName: Record<MarkerIconColor, string> = {
  [MarkerIconColor.Red]: styles.red
};